import { render, staticRenderFns } from "./red-packet-rain.vue?vue&type=template&id=3f1c63fa&scoped=true&"
import script from "./red-packet-rain.vue?vue&type=script&lang=js&"
export * from "./red-packet-rain.vue?vue&type=script&lang=js&"
import style0 from "./red-packet-rain.vue?vue&type=style&index=0&id=3f1c63fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c63fa",
  null
  
)

export default component.exports